function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.923 4.5L10.308 2l7.384 3-.461 10-6.923 6-7.385-6V4.5z",
  fill: "#28293D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.979 1.105c.199-.14.459-.14.658 0 2.3 1.615 4.788 2.623 7.469 3.026.292.044.51.308.51.619v5.625c0 4.864-2.739 8.413-8.095 10.583a.565.565 0 01-.426 0C4.738 18.788 2 15.24 2 10.375V4.75c0-.311.217-.575.51-.619 2.68-.403 5.168-1.41 7.469-3.026zm7.45 4.18a18.367 18.367 0 01-6.646-2.603l-.475-.31-.476.31a18.366 18.366 0 01-6.645 2.603v5.09c0 4.24 2.335 7.33 7.12 9.329 4.786-2 7.122-5.089 7.122-9.329v-5.09z",
  fill: "#28293D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 7.474C5 7.212 5.264 7 5.59 7h6.678c.325 0 .59.212.59.474 0 .261-.265.473-.59.473H5.589c-.325 0-.589-.212-.589-.473zM5 10c0-.262.264-.474.59-.474h9.82c.326 0 .59.212.59.474s-.264.474-.59.474H5.59c-.326 0-.59-.212-.59-.474zm0 2.526c0-.261.264-.473.59-.473h3.535c.325 0 .59.212.59.473 0 .262-.265.474-.59.474H5.589C5.264 13 5 12.788 5 12.526z",
  fill: "#fff"
});

function SvgLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgLight;